import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/configuracoes/estoque-final')({
  component: lazyRouteComponent(
    () => import('@/features/configuracoes/components/estoque-final-tab'),
    'EstoqueFinalTab'
  ),
})
